// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomNode_root__J6jht","expandIconWrapper":"CustomNode_expandIconWrapper__dO1-m","isOpen":"CustomNode_isOpen__2y6K2","labelGridItem":"CustomNode_labelGridItem__1Z4RG"};